const LETTERS = {
  ordinario: "O",
  sociosanitario: "S",
  "socio sanitario": "S",
  minorenne: "M",
  universitario: "U",
  dottorato: "D",
  residenziale: "R",
};

export function normalizeTipoIsee(tipo) {
  if (tipo == null || tipo === "") return null;
  return String(tipo).trim();
}

export function tipoIseeLetter(tipo) {
  const normalized = normalizeTipoIsee(tipo);
  if (!normalized) return "?";
  const key = normalized.toLowerCase().replace(/\s+/g, "");
  if (LETTERS[key]) return LETTERS[key];
  const keySpaced = normalized.toLowerCase();
  return LETTERS[keySpaced] || "?";
}

/** Es. "INPS-ISEE-2024-xxx · SocioSanitario (S)" oppure "SocioSanitario (S)" */
export function formatTipoIseeLabel(tipo, protocollo) {
  const name = normalizeTipoIsee(tipo);
  if (!name && !protocollo) return "";
  if (!name) return protocollo;
  const letter = tipoIseeLetter(name);
  if (protocollo) return `${protocollo} · ${name} (${letter})`;
  return `${name} (${letter})`;
}

/** Verde = Ordinario, giallo = SocioSanitario (e altri non-ordinario). */
export function tipoIseeBadgeClass(tipo) {
  const key = (normalizeTipoIsee(tipo) || "")
    .toLowerCase()
    .replace(/\s+/g, "");
  if (key === "ordinario") return "badge-success";
  if (key === "sociosanitario") return "badge-warning";
  return "badge-secondary";
}

export const TIPO_ISEE_RICHIESTO = {
  ORDINARIO: 0,
  SOCIO_SANITARIO: 1,
};
